import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Currency, CurrencyCreate, CurrencyFilter } from '../data/currency';

export function createCurrencyService(client: AxiosInstance) {
  return createCrudService<Currency, CurrencyCreate, CurrencyFilter>(
    client,
    '/Currency',
    'currencyId',
  );
}

export type CurrencyService = CrudService<Currency, CurrencyCreate, CurrencyFilter>;
